import { combineEpics } from 'redux-observable';
import { rootEpic as WorkspaceSettingsManagementEpic } from './views/WorkspaceSettingsManagement/epics';
import { rootEpic as NotificatonSettingsManagementEpic } from './views/WorkspaceSettingsManagement/components/NotificationSettings/epics/epics';
export const rootEpic = combineEpics(WorkspaceSettingsManagementEpic, NotificatonSettingsManagementEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
